import { HeadersEnum } from 'src/app/@Common/enum/headers.enum';
import { Injectable } from '@angular/core';
// import { SecureStorage } from 'secure-web-storage';


import * as CryptoJS from 'crypto-js';
import * as SHA1 from 'js-sha1';
import { VariablesEnum } from '../../enum/variables.enum';
import { environment } from '../../../../environments/environment';

// const SecureStorage = require('secure-web-storage');


@Injectable({
  providedIn: 'root'
})

export class StorageService {
  secretKey = 'conade';


  encrypt(value: string): string {
    return CryptoJS.AES.encrypt(value, this.secretKey.trim()).toString();
  }

  decrypt(textToDecrypt: string) {
    try {
      return CryptoJS.AES.decrypt(textToDecrypt, this.secretKey.trim()).toString(CryptoJS.enc.Utf8);
    } catch {
      return textToDecrypt;
    }
  }


  setItem(key: string, value: any) {
    const valorEncryptado = this.encrypt(JSON.stringify(value));
    localStorage.setItem(key, valorEncryptado);
  }

  getItem(key: string) {
    let value = localStorage.getItem(key);
    if (value) {
      value = this.decrypt(value);
    }
    return value;
  }

  getAccessToken(): string | null {
    if (typeof localStorage === 'undefined') {
      return null;
    }
    const sysId = environment.systemId || 1;
    const envName = (environment.environment || 'Desarrollo').trim().toLowerCase();
    return (
      localStorage.getItem(`accessToken_${sysId}_${envName}`) ||
      localStorage.getItem('accessToken') ||
      null
    );
  }

  async cerrarSesionBoveda(accessToken: string): Promise<void> {
    const baseUrl = (environment.bovedaUrl || '').replace(/\/+$/, '');
    const respuesta = await fetch(`${baseUrl}/Login/cancelar-access-token`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(accessToken)
    });

    if (!respuesta.ok) {
      throw new Error(`No se pudo revocar el token: ${respuesta.status}`);
    }
  }

  clearToken() {
    const sysId = environment.systemId || 1;
    const envName = (environment.environment || 'Desarrollo').trim().toLowerCase();

    localStorage.removeItem(VariablesEnum.usuario_conade);
    localStorage.removeItem(VariablesEnum.usuario);
    localStorage.removeItem(HeadersEnum.ACCION);
    localStorage.removeItem(HeadersEnum.USUARIO);

    localStorage.removeItem(`accessToken_${sysId}_${envName}`);
    localStorage.removeItem(`refreshToken_${sysId}_${envName}`);
    localStorage.removeItem(`user_${sysId}_${envName}`);
    localStorage.removeItem(`rolNombre_${sysId}_${envName}`);
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('rolNombre');
  }


  encryptPassword(psw: string) {
    const hash = SHA1(psw);
    return hash;
  }


}
